"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRateEstimateDto = instanceOfRateEstimateDto;
exports.RateEstimateDtoFromJSON = RateEstimateDtoFromJSON;
exports.RateEstimateDtoFromJSONTyped = RateEstimateDtoFromJSONTyped;
exports.RateEstimateDtoToJSON = RateEstimateDtoToJSON;
exports.RateEstimateDtoToJSONTyped = RateEstimateDtoToJSONTyped;
/**
 * Check if a given object implements the RateEstimateDto interface.
 */
function instanceOfRateEstimateDto(value) {
    if (!('nurseTakeHome' in value) || value['nurseTakeHome'] === undefined)
        return false;
    if (!('platformFee' in value) || value['platformFee'] === undefined)
        return false;
    if (!('employerFee' in value) || value['employerFee'] === undefined)
        return false;
    if (!('totalCost' in value) || value['totalCost'] === undefined)
        return false;
    if (!('totalCostUpperRange' in value) || value['totalCostUpperRange'] === undefined)
        return false;
    if (!('totalCostLowerRange' in value) || value['totalCostLowerRange'] === undefined)
        return false;
    return true;
}
function RateEstimateDtoFromJSON(json) {
    return RateEstimateDtoFromJSONTyped(json, false);
}
function RateEstimateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseTakeHome': json['nurseTakeHome'],
        'platformFee': json['platformFee'],
        'employerFee': json['employerFee'],
        'totalCost': json['totalCost'],
        'totalCostUpperRange': json['totalCostUpperRange'],
        'totalCostLowerRange': json['totalCostLowerRange'],
    };
}
function RateEstimateDtoToJSON(json) {
    return RateEstimateDtoToJSONTyped(json, false);
}
function RateEstimateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseTakeHome': value['nurseTakeHome'],
        'platformFee': value['platformFee'],
        'employerFee': value['employerFee'],
        'totalCost': value['totalCost'],
        'totalCostUpperRange': value['totalCostUpperRange'],
        'totalCostLowerRange': value['totalCostLowerRange'],
    };
}
//# sourceMappingURL=RateEstimateDto.js.map